export class Clinica {
    id?: number = -1;
    nome: string = "";
    cnpj: string = "";
    telefone: string = "";
    cep: string = "";
    logradouro: string = "";
    bairro: string = "";
    numero: string = "";
    cidade: string = "";
    complemento: string = "";
    uf: string = "";
    ativa: boolean = true;
}